/* eslint-disable react/no-danger */

/* eslint-disable react/button-has-type */

/* eslint-disable react/prop-types */

/* eslint-disable @next/next/no-img-element */
import React, { useContext, useState, useCallback } from "react";

import classNames from "classnames";
import { motion, AnimatePresence } from "framer-motion";
import { Modal as BootstrapModal } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styled, { useTheme } from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import breakpoints from "../../constants";
import Markdown from "../../styles/Markdown";
import {
  CustomRightArrow,
  CustomLeftArrow,
} from "../Carousel/CarouselArrows";

const BLOCK_CLASS = "profile-card-gallery";

const StyledWrapper = styled.div`
  
  width: 100%;
  max-width: 100%;
  position: relative;
  ${(props) =>
    props.$fullWidth
      ? `
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  `
      : ""}

  ${(props) => props.dynamicStyles}

  .react-multi-carousel-item {
    display: flex;
    align-items: stretch;
    justify-content: center;
    padding: 0 ${({ $itemGap }) => $itemGap || "10px"};
  }

  .custom-dot-list-style {
    margin-top: 20px;
  }

  .custom-dot-list-style button {
    border: none;
    background: ${(props) => props.$dotColor || "#ddd"};
    width: ${(props) => props.$dotSize || 10}px;
    height: ${(props) => props.$dotSize || 10}px;
    border-radius: 50%;
    margin: 0 5px;
    padding: 0;
    transition: background 0.3s;
  }

  .custom-dot-list-style .react-multi-carousel-dot--active button {
    background: ${(props) => props.$activeDotColor || "#666"};
  }

  .carousel-container {
    padding-bottom: 40px;
  }
`;

const StyledCard = styled.div`
  position: relative;
  width: 100%;
  height: ${({ $cardHeight }) => $cardHeight || "500px"};
  border-radius: ${({ $borderRadius }) => $borderRadius || "12px"};
  overflow: hidden;
  cursor: pointer;
  border: 3px solid transparent;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: ${({ $hoverBorderColor }) => $hoverBorderColor};
  }

  @media (max-width: ${breakpoints.TABLET}) {
    height: ${({ $mobileCardHeight }) => $mobileCardHeight || "450px"};
  }
`;

const CardImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CardGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.75) 0%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 1;

  @media (max-width: ${breakpoints.TABLET}) {
    display: none;
  }
`;

const CardTextOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  z-index: 2;
  color: #fff;
  text-align: center;

  @media (max-width: ${breakpoints.TABLET}) {
    display: none;
  }
`;

const CardName = styled.h3`
  font-weight: 900;
  font-size: 1.8rem;
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const CardTitle = styled.p`
  font-weight: 600;
  font-size: 0.85rem;
  margin: 0 0 2px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CardDepartment = styled.p`
  font-weight: 400;
  font-size: 0.8rem;
  margin: 0;
  opacity: 0.85;
`;

const MobilePanel = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 3;
  padding: 20px;
  text-align: center;
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  @media (max-width: ${breakpoints.TABLET}) {
    display: flex;
  }
`;

const HoverPanel = styled(motion.div)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 3;
  padding: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  @media (max-width: ${breakpoints.TABLET}) {
    display: none;
  }
`;

const HoverName = styled.h3`
  font-weight: 900;
  font-size: 1.6rem;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #000;
`;

const HoverTitle = styled.p`
  font-weight: 600;
  font-size: 0.8rem;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #333;
`;

const HoverDepartment = styled.p`
  font-weight: 400;
  font-size: 0.8rem;
  margin: 0;
  color: #555;
`;

const LearnMoreButton = styled.button`
  margin-top: 12px;
  padding: 10px 32px;
  border: 2px solid #000;
  border-radius: 50px;
  background: transparent;
  color: #000;
  font-weight: 800;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: #000;
    color: #fff;
  }
`;

const StyledModal = styled(BootstrapModal)`
  .modal-dialog {
    max-width: 900px;
  }

  .modal-content {
    border: none;
    border-radius: 0;
    background: ${({ $modalBackground }) => $modalBackground || "#2a2a2a"};
    color: #fff;
    overflow: visible;
  }

  .modal-body {
    padding: 0;
    position: relative;
  }
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 300px;

  @media (min-width: ${breakpoints.TABLET}) {
    flex-direction: row;
    min-height: 400px;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  padding: 24px 40px;
  overflow-y: auto;
  max-height: 80vh;

  @media (max-width: ${breakpoints.TABLET}) {
    padding: 20px 16px;
    max-height: 70vh;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #fff;
  }

  p {
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.6;
  }

  a {
    color: ${({ $accentColor }) => $accentColor};
  }
`;

const ModalCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

const ModalNavArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: ${({ $arrowColor }) => $arrowColor || "#e91e8c"};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-50%) scale(1.08);
  }

  ${({ $direction }) =>
    $direction === "left" ? "left: -24px;" : "right: -24px;"}

  @media (max-width: ${breakpoints.TABLET}) {
    display: none;
  }
`;

const ModalNavRow = styled.div`
  display: none;
  justify-content: center;
  gap: 16px;
  padding: 12px 0 16px;
  background: ${({ $bg }) => $bg || "#2a2a2a"};

  @media (max-width: ${breakpoints.TABLET}) {
    display: flex;
  }
`;

const ModalNavRowButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: ${({ $arrowColor }) => $arrowColor || "#e91e8c"};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const panelVariants = {
  hidden: { y: "100%", opacity: 0 },
  visible: { y: 0, opacity: 1 },
};

function ProfileCard({
  item,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onLearnMore,
  cardHeight,
  mobileCardHeight,
  borderRadius,
  hoverBorderColor,
  buttonText,
}) {
  return (
    <StyledCard
      className={`${BLOCK_CLASS}__card`}
      $cardHeight={cardHeight}
      $mobileCardHeight={mobileCardHeight}
      $borderRadius={borderRadius}
      $hoverBorderColor={hoverBorderColor}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onLearnMore}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onLearnMore();
      }}
    >
      <CardImage
        className={`${BLOCK_CLASS}__card-image`}
        src={item.image?.url || ""}
        alt={item.image?.alternativeText || item.name || "Profile image"}
      />

      {/* Desktop: gradient + text overlay, hidden when hovered */}
      {!isHovered && (
        <>
          <CardGradient className={`${BLOCK_CLASS}__card-gradient`} />
          <CardTextOverlay className={`${BLOCK_CLASS}__card-overlay`}>
            {item.name && (
              <CardName className={`${BLOCK_CLASS}__card-name`}>
                {item.name}
              </CardName>
            )}
            {item.title && (
              <CardTitle className={`${BLOCK_CLASS}__card-title`}>
                {item.title}
              </CardTitle>
            )}
            {item.department && (
              <CardDepartment className={`${BLOCK_CLASS}__card-department`}>
                {item.department}
              </CardDepartment>
            )}
          </CardTextOverlay>
        </>
      )}

      {/* Desktop: animated panel on hover */}
      <AnimatePresence>
        {isHovered && (
          <HoverPanel
            className={`${BLOCK_CLASS}__card-hover-panel`}
            variants={panelVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            {item.name && (
              <HoverName className={`${BLOCK_CLASS}__card-hover-name`}>
                {item.name}
              </HoverName>
            )}
            {item.title && (
              <HoverTitle className={`${BLOCK_CLASS}__card-hover-title`}>
                {item.title}
              </HoverTitle>
            )}
            {item.department && (
              <HoverDepartment
                className={`${BLOCK_CLASS}__card-hover-department`}
              >
                {item.department}
              </HoverDepartment>
            )}
            <LearnMoreButton
              className={`${BLOCK_CLASS}__card-button`}
              onClick={(e) => {
                e.stopPropagation();
                onLearnMore();
              }}
            >
              {buttonText}
            </LearnMoreButton>
          </HoverPanel>
        )}
      </AnimatePresence>

      {/* Mobile: always-visible panel (no hover on touch) */}
      <MobilePanel className={`${BLOCK_CLASS}__card-mobile-panel`}>
        {item.name && <HoverName>{item.name}</HoverName>}
        {item.title && <HoverTitle>{item.title}</HoverTitle>}
        {item.department && (
          <HoverDepartment>{item.department}</HoverDepartment>
        )}
        <LearnMoreButton
          className={`${BLOCK_CLASS}__card-button`}
          onClick={(e) => {
            e.stopPropagation();
            onLearnMore();
          }}
        >
          {buttonText}
        </LearnMoreButton>
      </MobilePanel>
    </StyledCard>
  );
}

function ProfileCardGallery() {
  const {
    profileCards: contextCards,
    slidesPerView = "three",
    autoPlay = true,
    autoPlaySpeed = 3000,
    infiniteLoop = true,
    showArrows = true,
    showDots = true,
    hideArrowsOnMobile = true,
    itemGap = "10px",
    cardBorderRadius = "12px",
    cardHeight = "500px",
    mobileCardHeight = "450px",
    hoverBorderColor,
    buttonText = "LEARN MORE",
    modalBackground = "#2a2a2a",
    modalArrowColor,
    arrowSize = 24,
    arrowColor = "#fff",
    dotSize = 10,
    dotColor = "#ddd",
    activeDotColor = "#666",
    transitionDuration = 500,
    CSS,
    uniqueId,
    wrapperClassName,
    fullWidth = false,
  } = useContext(ComponentContext);

  const profileCards = contextCards || [];

  const theme = useTheme();

  const [hoveredCard, setHoveredCard] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [activeModalIndex, setActiveModalIndex] = useState(0);

  const resolvedBorderColor =
    hoverBorderColor || theme?.primaryColor || "#e91e8c";
  const resolvedArrowColor =
    modalArrowColor || theme?.primaryColor || "#e91e8c";

  const slidesMap = {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
  };
  const slidesToShow = slidesMap[slidesPerView] || 3;

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: slidesToShow,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: Math.min(slidesToShow, 2),
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const hideArrowsOn = [];
  if (!showArrows) {
    hideArrowsOn.push("desktop", "tablet", "mobile");
  } else if (hideArrowsOnMobile) {
    hideArrowsOn.push("tablet", "mobile");
  }

  const openModal = useCallback((index) => {
    setActiveModalIndex(index);
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const goToNext = useCallback(() => {
    setActiveModalIndex((prev) =>
      prev < profileCards.length - 1 ? prev + 1 : 0,
    );
  }, [profileCards.length]);

  const goToPrev = useCallback(() => {
    setActiveModalIndex((prev) =>
      prev > 0 ? prev - 1 : profileCards.length - 1,
    );
  }, [profileCards.length]);

  if (!profileCards?.length) {
    return null;
  }

  const activeItem = profileCards[activeModalIndex];

  return (
    <>
      <StyledWrapper
        className={classNames(BLOCK_CLASS, wrapperClassName)}
        id={uniqueId}
        dynamicStyles={CSS}
        $fullWidth={fullWidth}
        $itemGap={itemGap}
        $dotSize={dotSize}
        $dotColor={dotColor}
        $activeDotColor={activeDotColor}
      >
        <Carousel
          responsive={responsive}
          infinite={infiniteLoop}
          removeArrowOnDeviceType={hideArrowsOn}
          autoPlay={autoPlay}
          autoPlaySpeed={autoPlaySpeed}
          keyBoardControl
          pauseOnHover
          showDots={showDots}
          renderDotsOutside
          swipeable
          draggable
          customTransition={`transform ${transitionDuration}ms ease-in-out`}
          transitionDuration={transitionDuration}
          shouldResetAutoplay={false}
          customRightArrow={
            <CustomRightArrow arrowSize={arrowSize} arrowColor={arrowColor} />
          }
          customLeftArrow={
            <CustomLeftArrow arrowSize={arrowSize} arrowColor={arrowColor} />
          }
          containerClass={`${BLOCK_CLASS}__carousel carousel-container`}
          dotListClass={`${BLOCK_CLASS}__dots custom-dot-list-style`}
        >
          {profileCards.map((item, index) => (
            <ProfileCard
              key={item.uniqueId || `profile-${index}`}
              item={item}
              isHovered={hoveredCard === (item.uniqueId || index)}
              onMouseEnter={() => setHoveredCard(item.uniqueId || index)}
              onMouseLeave={() => setHoveredCard(null)}
              onLearnMore={() => openModal(index)}
              cardHeight={cardHeight}
              mobileCardHeight={mobileCardHeight}
              borderRadius={cardBorderRadius}
              hoverBorderColor={resolvedBorderColor}
              buttonText={buttonText}
            />
          ))}
        </Carousel>
      </StyledWrapper>

      <StyledModal
        className={`${BLOCK_CLASS}__modal`}
        show={modalOpen}
        onHide={closeModal}
        centered
        size="lg"
        $modalBackground={modalBackground}
      >
        <BootstrapModal.Body className={`${BLOCK_CLASS}__modal-body`}>
          <ModalCloseButton
            className={`${BLOCK_CLASS}__modal-close`}
            onClick={closeModal}
            aria-label="Close modal"
          >
            ✕
          </ModalCloseButton>

          {profileCards.length > 1 && (
            <>
              <ModalNavArrow
                className={`${BLOCK_CLASS}__modal-nav-arrow`}
                $direction="left"
                $arrowColor={resolvedArrowColor}
                onClick={goToPrev}
                aria-label="Previous profile"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 18L9 12L15 6"
                    stroke="#fff"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ModalNavArrow>
              <ModalNavArrow
                className={`${BLOCK_CLASS}__modal-nav-arrow`}
                $direction="right"
                $arrowColor={resolvedArrowColor}
                onClick={goToNext}
                aria-label="Next profile"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#fff"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ModalNavArrow>
            </>
          )}

          <ModalBody className={`${BLOCK_CLASS}__modal-content-wrap`}>
            <ModalContent
              className={`${BLOCK_CLASS}__modal-content`}
              $accentColor={resolvedArrowColor}
            >
              {activeItem?.modalContent && (
                <Markdown>{activeItem.modalContent}</Markdown>
              )}
            </ModalContent>
          </ModalBody>

          {profileCards.length > 1 && (
            <ModalNavRow
              className={`${BLOCK_CLASS}__modal-nav-row`}
              $bg={modalBackground}
            >
              <ModalNavRowButton
                className={`${BLOCK_CLASS}__modal-nav-row-button`}
                $arrowColor={resolvedArrowColor}
                onClick={goToPrev}
                aria-label="Previous profile"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M15 18L9 12L15 6"
                    stroke="#fff"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ModalNavRowButton>
              <ModalNavRowButton
                className={`${BLOCK_CLASS}__modal-nav-row-button`}
                $arrowColor={resolvedArrowColor}
                onClick={goToNext}
                aria-label="Next profile"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#fff"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ModalNavRowButton>
            </ModalNavRow>
          )}
        </BootstrapModal.Body>
      </StyledModal>
    </>
  );
}

export default ProfileCardGallery;
